import styled from 'styled-components';
import { headerHeight, mediaQuery } from '~/styled';

export const MainContent = styled.main<{ $onWebview: boolean }>`
  display: block;
  height: ${({ $onWebview }) =>
    $onWebview ? '100%' : `calc(100% - ${headerHeight} - var(--top-banner-offset, 0px))`};
  ${mediaQuery.up.s`
    display: flex;
    flex-grow: 1;
    max-width: 100%;
    height: calc(100% - ${headerHeight} - var(--top-banner-offset, 0px));
  `}
`;
